import { render, staticRenderFns } from "./Shirotchampi.vue?vue&type=template&id=10a0fc42&scoped=true"
import script from "./Shirotchampi.vue?vue&type=script&lang=js"
export * from "./Shirotchampi.vue?vue&type=script&lang=js"
import style0 from "./Shirotchampi.vue?vue&type=style&index=0&id=10a0fc42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a0fc42",
  null
  
)

export default component.exports